import * as React from "react";

const PylonIcon = (props: { width?: number; height?: number }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    width={props.width ?? 20}
    height={props.height ?? 20}
    fill="none"
  >
    {/* Outer circle */}
    <circle cx="50" cy="50" r="44" stroke="#222326" strokeWidth="5" />
    {/* Right semicircle solid fill — its left edge doubles as the centre divider */}
    <path d="M50 6 A44 44 0 0 1 50 94 Z" fill="#222326" />
    {/* Three horizontal stripes in the lower-left of the circle */}
    <line x1="7"  y1="63" x2="49" y2="63" stroke="#222326" strokeWidth="5" strokeLinecap="round" />
    <line x1="11" y1="73" x2="49" y2="73" stroke="#222326" strokeWidth="5" strokeLinecap="round" />
    <line x1="19" y1="83" x2="49" y2="83" stroke="#222326" strokeWidth="5" strokeLinecap="round" />
  </svg>
);

export default PylonIcon;
